import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import States from './States';

class Address extends React.Component {

    handleOnChange = (e) => {
        const { addressChanged, fromTrainingPage = false } = this.props
        const { target: { name, value } } = e;
        if (fromTrainingPage) 
            addressChanged();
        this.props.onChange(name, value);
    };

    handleStateChange = (stateId) => this.props.onChange('stateId', stateId);

    render() {

        const { line1, line2, city, zipCode, stateId, states} = this.props;

        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Address Line 1:</Label>
                            <Input type='text' name='line1' value={line1 || ''} onChange={this.handleOnChange}></Input>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Address Line 2:</Label>
                            <Input type='text' name='line2' value={line2 || ''} onChange={this.handleOnChange}></Input>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>City:</Label>
                            <Input type='text' name='city' value={city || ''} onChange={this.handleOnChange}></Input>
                        </FormGroup>
                    </Col>
                    <Col>
                        <States
                            states={states}
                            value={stateId || ''}
                            onChange={this.handleStateChange}
                        />
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>Zip Code:</Label>
                            <Input type='text' name='zipCode' value={zipCode || ''} onChange={this.handleOnChange}></Input>
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

Address.propTypes = {
    states: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
}

export default Address;